import * as types from './mutation-types';
import * as $cache from '@/common/cache';
import Cookies from 'js-cookie';

const mutations = {
  [types.FETCH_USER](state, payload) {
    state.user = payload;
  },
  [types.FETCH_TOKEN](state, payload) {
    state.token = payload;
  },
  [types.FETCH_SYNC_USER](state, payload) {
    state.sysUser = payload;
  },
  [types.SYNC_LOGOUT](state) {
    state.sysUser = {};

    // clear cache
    Cookies.remove('advanced-frontend', {
      domain: '.aiclk.com',
      path: '/',
    });
    $cache.localClear($cache.AUTH);
  },

  [types.SET_PERMS](state, payload) {
    state.perms = payload.data;
  },

  [types.POP_AMIS_EDITOR](state, payload = {}) {
    state.amisEditor.visible = true;
    state.amisEditor.id = payload.id || '';
    state.amisEditor.path = payload.path || '';
  },

  [types.UPDATE_AMIS_EDITOR](state, payload) {
    state.amisEditor.json = payload || {};
  },

  [types.PUSH_AMIS_EDITOR](state, payload) {
    state.amisEditor.visible = false;
    state.amisEditor.id = '';
    state.amisEditor.path = '';
  },
};

export default mutations;
